import { AUTO_SUBMIT_FORM, USER_SUBMIT_FORM } from "./form-submitted-action-types";
import { constructSubmitUrl, deriveSubmitData, submitToBizible } from "./form-submitted-services";

// TODO FIXME XXX This results in a bunch of iFrames added to the dom, try again with AJAX.
const submitWithIframe = (postUrl) => {
    const iframe = document.createElement("iframe");
    const onReady = () => {
        iframe.remove();
    };
    iframe.className = "background-submit";
    iframe.style.display = "none";
    iframe.src = postUrl;
    iframe.onreadystatechange = onReady();
    iframe.onload = onReady();
    document.body.append(iframe);
};

const userSubmitToEloqua = (vertical) => (dispatch, getState) => {
    const { formData } = getState();
    submitToBizible(formData.email); // side effect
    const submitData = deriveSubmitData(vertical, formData);
    const postUrl = constructSubmitUrl(submitData);
    submitWithIframe(postUrl);
    dispatch({
        type: USER_SUBMIT_FORM,
        submitData
    });
};
const autoSubmitToEloqua = (vertical) => (dispatch, getState) => {
    const { formData } = getState();
    const submitData = deriveSubmitData(vertical, formData);
    const postUrl = constructSubmitUrl(submitData);
    submitWithIframe(postUrl);
    dispatch({
        type: AUTO_SUBMIT_FORM,
        submitData
    });
};

export default {
    autoSubmitToEloqua,
    userSubmitToEloqua
};
